import { Button, ButtonVariant, Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { setIsOverlayLogin, useAppDispatch, useTranslation } from "@next-platform/client-common-core";
import { useCallback } from "react";

import { PageLayout, PageSize } from "@/components";
import Trans from "@/components/Trans/Trans";

import getAnonData from "./anondata";

const AnonymousMarketing = ({ datakey }: { datakey: keyof ReturnType<typeof getAnonData> }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const displayLoginOverlay = useCallback(() => {
    dispatch(setIsOverlayLogin(true));
  }, [dispatch]);

  const source = getAnonData(t)[datakey];

  return (
    <PageLayout size={PageSize.Large}>
      <section className="text-center max-w-[1000px] mx-auto py-10">
        <div className="flex flex-col gap-y-lg mx-auto">
          <hgroup>
            <Text centered as="h1" className="my-0">
              <Text
                variant={TextVariants.HEADING_1_MEDIUM}
                centered
                as="span"
                className="tracking-[-0.05em] sm:text-6xl sm:leading-[76px] my-0 block"
              >
                {source.heading}
              </Text>{" "}
              <Text
                variant={TextVariants.HEADING_1_MEDIUM}
                centered
                as="span"
                className="tracking-normal sm:text-6xl sm:leading-[62px] bg-transparent text-blue-10"
              >
                {source.mark}
              </Text>
            </Text>
          </hgroup>
          <Text variant={TextVariants.HEADING_6_REGULAR} centered>
            {source.punch}
          </Text>
        </div>
        <div>
          <Button
            variant={ButtonVariant.SECONDARY}
            className="z-20 rounded-[6px] my-14
             bg-black text-white dark:bg-white dark:text-black"
            onClick={displayLoginOverlay}
          >
            <Trans i18nKey="common:createFreeAccount" />
          </Button>
        </div>
        <div className="grid mob:grid-cols-[repeat(3,1fr)] gap-2.5">
          {source.cards.map(({ title, body, icon }) => (
            <figure
              key={title}
              className="grid grid-rows-subgrid [grid-row:span_3] justify-items-center gap-0 gap-y-[16px] border-1 mx-auto w-full max-w-96 border-solid border-gray-5 dark:border-gray-8 rounded-lg px-lg sm:px-2.5 md:px-lg py-[39px]"
            >
              <Icon
                size={IconSize.MEDIUM}
                icon={IconVariants[icon as keyof typeof IconVariants]}
                className="bg-blue-10 size-12 p-2.5 rounded-lg text-white"
              />
              <Text className="mb-1" centered variant={TextVariants.HEADING_5_BOLD}>
                {title}
              </Text>
              <Text centered className="text-pretty max-w-[200px]">
                {body}
              </Text>
            </figure>
          ))}
        </div>
      </section>
    </PageLayout>
  );
};
export default AnonymousMarketing;
